import {
  AppBar,
  Button,
  Grid,
  Paper,
  Tab,
  Tabs,
  Typography
} from '@material-ui/core'
import { AuthContext, List, useListRepository } from 'elentari'
import React, { useContext, useEffect, useState } from 'react'
import { restApi } from '../../services/Api'
import { formatDateTime } from '../../utils/Formatter'
import MensagemUsuarioRepository from './MensagemUsuarioRepository'
import ReactHtmlParser from 'react-html-parser'

const Mensagem = ({ mensagem }) => {
  if (mensagem) {
    return (
      <>
        <Grid item xs={12} style={{ wordWrap: 'break-word' }}>
          <strong>Autor:</strong> {mensagem?.mensagem?.usuario?.nome}
        </Grid>
        <Grid item xs={12} style={{ wordWrap: 'break-word' }}>
          {ReactHtmlParser(mensagem?.mensagem?.mensagem)}
        </Grid>
      </>
    )
  }
  return null
}

const UsuarioLerMensagem = ({ usuario }) => {
  const [mensagem, setMensagem] = useState(null)
  const [qtdMensagens, setQtdMensagens] = useState(0)

  const timer =
    qtdMensagens > 0 && mensagem?.id
      ? setTimeout(() => marcarLida(), 5 * 1000)
      : null

  const fetchMensagem = async () => {
    const responseMsg = await restApi.get(
      `usuarios/${usuario?.id}/mensagem-usuarios?filter[where][foiLida]=false`
    )
    if (responseMsg.ok) {
      const [firstMsg = null] = responseMsg?.data
      const msg = firstMsg
      setMensagem(msg)
    }
  }

  const fetchCount = async () => {
    const responseCount = await restApi.get(
      `usuarios/${usuario?.id}/mensagem-usuarios/count`,
      { where: { foiLida: false } }
    )
    if (responseCount.ok) {
      const { count } = responseCount?.data
      setQtdMensagens(count)
    }
  }

  useEffect(() => {
    fetchCount()
    fetchMensagem()
  }, [])

  const marcarLida = async () => {
    await restApi.patch(`mensagens-usuario/${mensagem?.id}`, { foiLida: true })
  }

  return (
    <Paper>
      <Grid container spacing={2} style={{ padding: 16 }}>
        <Grid item xs={12}>
          <Typography variant="h6">
            <strong>Mensagens </strong>({qtdMensagens})
          </Typography>
        </Grid>
        <Mensagem mensagem={mensagem} />
        <Grid item xs={12}>
          <Button
            variant="contained"
            onClick={async () => {
              if (timer) clearTimeout(timer)
              await marcarLida()
              await fetchCount()
              await fetchMensagem()
            }}
            disabled={qtdMensagens === 0}
          >
            {qtdMensagens < 2 ? 'Marcar como lida' : 'Próxima mensagem'}
          </Button>
        </Grid>
      </Grid>
    </Paper>
  )
}

const listOptions = {
  defaultOrder: 'id desc',
  fields: {
    createdAt: {
      label: 'Data',
      format: valor => (valor ? formatDateTime(valor.createdAt) : ''),
      noOrder: true
    },
    mensagem: {
      label: 'Mensagem',
      format: mensagem => (mensagem ? ReactHtmlParser(mensagem?.mensagem) : ''),
      noOrder: true
    },
    usuario: {
      label: 'Autor',
      format: (_, mensagem) => {
        return mensagem?.mensagem?.usuario?.nome
      },
      noOrder: true
    }
  }
}

const TodasMensagens = ({ usuario, ...props }) => {
  const listHook = useListRepository({
    repository: MensagemUsuarioRepository(usuario),
    path: 'mensagens',
    defaultSort: 'id desc',
    query: [['foiLida', true]]
  })

  listHook.state.list = listHook.state.list.map(mensagem => ({
    ...mensagem,
    createdAt: mensagem.mensagem
  }))

  return (
    <Paper>
      <Grid container spacing={2} style={{ padding: 16 }}>
        <Grid item xs={12}>
          <List
            {...props}
            {...listHook}
            listOptions={listOptions}
            onClickView={null}
            onClickEdit={null}
            removeItem={null}
            onClickNew={null}
            hideDownloadIcon
          />
        </Grid>
      </Grid>
    </Paper>
  )
}

const Aba = props => {
  const { children, value, index, ...other } = props
  return (
    <Grid
      container
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      <Grid item xs={12}>
        {value === index && children}
      </Grid>
    </Grid>
  )
}
const Abas = props => {
  const authContext = useContext(AuthContext)
  const usuario = authContext.user

  const [abaSelecionada, setAbaSelecionada] = useState('nao-visualizadas')

  const handleChange = (event, newValue) => {
    setAbaSelecionada(newValue)
  }

  return (
    <Grid
      container
      style={{
        flexGrow: 1
      }}
    >
      <AppBar position="static" color="secondary">
        <Tabs
          value={abaSelecionada}
          onChange={handleChange}
          aria-label="abas de mensages"
        >
          <Tab label="Não visualizadas" value="nao-visualizadas" />
          <Tab label="Todas" value="todas" />
        </Tabs>
      </AppBar>
      <Aba value={abaSelecionada} index="nao-visualizadas">
        <UsuarioLerMensagem usuario={usuario} />
      </Aba>
      <Aba value={abaSelecionada} index="todas">
        <TodasMensagens usuario={usuario} {...props} />
      </Aba>
    </Grid>
  )
}

export default Abas
